module.exports = __webpack_public_path__ + "static/media/20_000012.99c0a71d.jpg";